import React from 'react';
import { Tfoot, Tr, Td } from '@wegroup/design-system';
import { flexRender, HeaderGroup } from '@tanstack/react-table';

interface Props<TData> {
  footerGroups: HeaderGroup<TData>[];
}

const ReactTableV8Footer = <TData,>({ footerGroups }: Props<TData>) => {
  return (
    <Tfoot>
      {footerGroups.map((group) => (
        <Tr key={group.id}>
          {group.headers.map((header) => (
            <Td key={header.id}>
              {header.isPlaceholder
                ? null
                : flexRender(header.column.columnDef.footer, header.getContext())}
            </Td>
          ))}
        </Tr>
      ))}
    </Tfoot>
  );
};

export default ReactTableV8Footer;



